import { ArticleHeading2, ArticleHeading3, TDeviceType, UIText1 } from '@cian/ui-kit';
import { clsx as cn } from 'clsx';
import * as React from 'react';

import styles from './HowItWorks.css';
import okayIcon from './assets/okay.svg';
import { TYPOGRAPHY, HIW_DATA } from './constants';
import { NBSP } from '../../constants/symbols';
import { Section } from '../Section';
import { SectionTitle } from '../SectionTitle';

interface IHowItWorksProps {
  deviceType: TDeviceType;
}

export const HowItWorks: React.FC<IHowItWorksProps> = ({ deviceType }) => {
  const AdaptiveHeading = deviceType === 'phone' ? ArticleHeading3 : ArticleHeading2;

  return (
    <Section deviceType={deviceType}>
      <div className={cn(styles['container'], styles[`container-${deviceType}`])}>
        <SectionTitle deviceType={deviceType}>{TYPOGRAPHY.SECTION_TITLE}</SectionTitle>
        <ul className={cn(styles['list'], styles[`list-${deviceType}`])}>
          {HIW_DATA.map(({ text }, hiwIndex) => (
            <li className={cn(styles['list-item'], styles[`list-item-${deviceType}`])} key={hiwIndex}>
              <div className={styles['list-item-container']}>
                <img src={okayIcon} alt="Иконка карточки" className={styles['list-item-image']} loading="lazy" />
                <UIText1 color="white_60">{`${hiwIndex + 1}${NBSP}шаг`}</UIText1>
              </div>
              <div className={styles[`list-item-text-${deviceType}`]}>
                <AdaptiveHeading color="white_100">{text}</AdaptiveHeading>
              </div>
            </li>
          ))}
        </ul>
        <h4 className={cn(styles['attention'], styles[`attention-${deviceType}`])}>{TYPOGRAPHY.SECTION_WARNING}</h4>
      </div>
    </Section>
  );
};
